import createReducer from 'shared/createReducer';
import { NEWSLETTER_FAILURE, NEWSLETTER_SUCCESS, NEWSLETTER_FETCHING } from '../constants/action_types';

const initialState = {
    error: false,
    success: false,
    isFetching: false
};

const newsletterSuccess = (state, action) => ({
    ...state,
    error: false,
    success: action.email,
    isFetching: false
});

const newsletterFailure = (state, action) => ({
    ...state,
    error: action.error,
    success: false,
    isFetching: false
});

const newsletterFetching = (state, action) => ({
    ...state,
    error: false,
    success: false,
    isFetching: true
});

const newsletterReducer = createReducer(initialState, {
    [NEWSLETTER_SUCCESS]: newsletterSuccess,
    [NEWSLETTER_FAILURE]: newsletterFailure,
    [NEWSLETTER_FETCHING]: newsletterFetching,
});

export default newsletterReducer;